<template>
    <div class="cookie-popup" v-if="state.show">
        <div class="cookie-popup__container">
            <div class="cookie-popup__inner">
                <div class="row v-center between">
                    <div class="col d8 sm-12 cookie-popup__col">
                        <div class="cookie-popup__title">{{params.messages.title}}</div>
                        <div class="cookie-popup__text">{{params.messages.text}}</div>
                    </div>
                    <div class="col d4 sm-12 cookie-popup__col">
                        <div class="flex v-center cookie-popup__actions flex-end">
                            <ABtn :href="params.detailLink" :label="params.messages.btnDetail" class="gray cookie-popup__settings-btn" />
                            <ABtn :label="params.messages.btnConfirm" class="dark cookie-popup__success-btn" @click="sendSuccess" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useCookies } from "vue3-cookies"
import { ABtn } from '../ui' 
import { ref } from 'vue'

export default {
    name: 'CookiePopup',
    props: ['params'],
    components: {
        ABtn,
    },
    setup: (props, ctx) => {
        
        const state = ref({
            show: props.params.show,
        });
        const { cookies } = useCookies();
        const sendSuccess = (() => {
            cookies.set(props.params.ident, true, "365d");
            state.value.show = false;
        });

        return {
            state,
            cookies,
            sendSuccess,
        }
    },
}
</script>

<style lang="scss">
    .cookie-popup {
        position: fixed;
        left: 0;
        bottom: 40px;
        width: 100%;
        z-index: 100;
        @include tablet {
            bottom: 16px;
        }

        &__container {
            padding: 0 44px;
            margin: 0 auto;
            @include tablet {
                padding: 0 15px;
            }
        }
        &__inner {
            background: #fff;
            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
            border-radius: var(--br-1);
            overflow: hidden;
            padding: 24px 32px;
            max-width: 1500px;
            margin: 0 auto;

            @include tablet {
                padding: 24px;
            }

            @include mobile {
                padding: 16px;
            }
        }
        &__title {
            font-family: var(--font-secondary);
            font-weight: 600;
            font-size: 22px;
            line-height: 28px;

            @include mobile {
                font-size: 18px;
                line-height: 22px;
            }
        }
        &__text {
            font-size: 14px;
            line-height: 20px;
            margin-top: 16px;
            max-width: 865px;

            @include mobile {
                font-size: 12px;
                line-height: 16px;
            }
        }
        &__actions {
            @include tablet {
                flex-direction: column-reverse;
            }
            @include mobile {
                margin-top: 16px;
                flex-direction: row;
            }
            .a-btn {
                min-width: 200px;
                margin-left: 10px;
                @include tablet {
                    margin-left: 0;
                    min-width: 150px;
                }
                @include mobile {
                    min-width: initial;
                    width: calc(50% - 5px);
                }
                &:first-child {
                    margin-left: 0;
                }
            }
        }
        &__settings-btn {
            @include tablet {
                margin-top: 10px;
            }
            @include mobile {
                margin-right: 5px;
                margin-top: 0;
            }
        }
        &__success-btn {
            @include mobile {
                margin-left: 5px !important;
            }
        }
    }
</style>